var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('pre-base',{ref:"mybase",attrs:{"pre_data":_vm.init_data},on:{"base2-event":_vm.refresh_father}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('div',{attrs:{"id":"notice"}},[_c('h5',[_vm._v("考勤审核单说明:")]),_c('span',[_vm._v("1、业务说明:审核提交过来的请假单和调休单=>通过后修改对应考勤模板为请假状态!")]),_c('br'),_c('span',[_vm._v("2、查询关键字:单号。")]),_c('br')])])
}]

export { render, staticRenderFns }